module.exports = __webpack_public_path__ + "img/efb2e390b7cd07b2a8860145f624dbfc.png";